// @flow

import * as React from "react"
import {connect} from "react-redux"
import ClassNames from "classnames"
import {withTranslation} from "react-i18next"

import {is} from "../../abilities"
import {
  fetchBabiesPaged,
  setBabiesListType,
  fetchBabiesMadams,
} from "../../actions/babies"
import BabyCardList from "../../components/baby-card-list"
import BabiesFilters from "../../components/babies-filters"
import BabiesSearch from "../../components/babies-search"
import BabiesSorters from "../../components/babies-sorters"
import // getFilteredAndSortedBabies,
// getMadamsForBabies,
"../../reducers/babies"
import Config from "../../config"
import type {State as ReduxState, Dispatch, BabiesState} from "../../types"

type Props = {
  dispatch: Dispatch,
  isAdmin: boolean,
  babiesState: BabiesState,
  t: any,
}

type State = {
  +babyId: ?number,
}

class BabiesDashboardView extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {babyId: Config.data.babyId}
    this.props.dispatch(setBabiesListType(Config.data.listType))
  }

  componentDidMount() {
    // for dashboard views, the base entities are already output in the html
    this.props.dispatch(fetchBabiesMadams())
    this.props.dispatch(fetchBabiesPaged())
  }

  render() {
    const {babiesState} = this.props
    const {babyId} = this.state
    const classNames = ClassNames("baby-lists-dashboard", {
      "dashboard-view ": !babyId,
    })
    const showStateFilter = ![
      "lost",
      "closed",
      "prospect",
      "dispatched",
    ].includes(babiesState.listType)
    const header = !babyId ? (
      <div className="mb-2 text-right mt-3">
        <BabiesSearch />
        <BabiesFilters
          madams={babiesState.madams}
          showState={showStateFilter}
        />
        <BabiesSorters />
      </div>
    ) : null
    return (
      <div className={classNames}>
        <div className="container has-sidebar">
          {header}
          <BabyCardList babies={babiesState.entities} />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state: ReduxState) => ({
  babiesState: state.babies,
  isAdmin:
    state.user.entity &&
    (is(state.user.entity, "admin") || is(state.user.entity, "superuser")),
})

export default withTranslation()(connect(mapStateToProps)(BabiesDashboardView))
